import { createAction } from 'redux-actions';

import { TOGGLE_MODAL, SCROLL_IS_BOTTOM } from './types';

export const toggleModal = createAction(TOGGLE_MODAL);
export const scrollIsBottom = createAction(SCROLL_IS_BOTTOM);
